module.exports = __webpack_public_path__ + "img/momo_button_redeem_active.421c5064.png";